import { isRequired } from "./isRequired";
import { Callback } from "./Callback";
import { Mobile } from "./Mobile";
import { Email } from "./Email";
import { Empty } from "./Empty";
import { Length, ILengthAttribute } from "./Length";

export interface IValidatedAttribute extends ILengthAttribute {
    
}

export type TypeValidators = {
    isRequired: isRequired;
    Callback: Callback;
    Mobile: Mobile;
    Email: Email,
    Empty: Empty,
    Length: Length
};

const ValidationRules = {
    isRequired,
    Callback,
    Email,
    Mobile,
    Empty,
    Length
};

export default ValidationRules;
